<template>
  <div>
    <inputbox name="find-location" :stacked="true" v-model="location">
      <div slot="rightBtn">
        <button class="btn btn-primary" v-on:click.prevent="search">
          Search
        </button>
      </div>
    </inputbox>
    <div class="map-section">
      <div id="map"></div>
      <div v-if="streetView" id="streetView"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    streetView: {
      type: Boolean,
      default: false
    },
    initialCenter: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      location: null,
      center: this.initialCenter,
      pov: {
        heading: 34,
        pitch: 10
      }
    };
  },

  mounted() {
    window.GoogleMapsLoader.load(google => {
      let center = this.center;

      let options = {
        center: center,
        zoom: 14
      };

      window.map = new google.maps.Map(document.getElementById('map'), options);

      if (this.streetView) {
        let streetView = new google.maps.StreetViewPanorama(
          document.getElementById('streetView'),
          {
            position: center,
            pov: {
              heading: 34,
              pitch: 10
            }
          }
        );

        streetView.addListener('position_changed', () => {
          this.center = {
            lat: streetView.getPosition().lat(),
            lng: streetView.getPosition().lng()
          };

          let center = Object.assign({}, this.center);
          center.location = this.location;
          this.$emit('set-center', center);
        });

        streetView.addListener('pov_changed', () => {
          this.pov = {
            heading: streetView.getPov().heading,
            pitch: streetView.getPov().pitch
          };
          this.$emit('set-pov', this.pov);
        });

        window.map.setStreetView(streetView);
      }
    });
  },

  methods: {
    search() {
      let request = new XMLHttpRequest();

      request.onreadystatechange = () => {
        if (request.readyState === XMLHttpRequest.DONE) {
          let data = JSON.parse(request.response);

          this.center = {
            lat: parseFloat(data.results[0].geometry.location.lat),
            lng: parseFloat(data.results[0].geometry.location.lng)
          };

          window.map.setCenter(
            new window.google.maps.LatLng(this.center.lat, this.center.lng)
          );

          let streetView = new window.google.maps.StreetViewPanorama(
            document.getElementById('streetView'),
            {
              position: this.center,
              pov: {
                heading: 34,
                pitch: 10
              }
            }
          );

          streetView.addListener('position_changed', () => {
            this.center = {
              lat: streetView.getPosition().lat(),
              lng: streetView.getPosition().lng()
            };
            let center = Object.assign({}, this.center);

            center.location = this.location;
            this.$emit('set-center', center);
          });

          streetView.addListener('pov_changed', () => {
            this.pov = {
              heading: streetView.getPov().heading,
              pitch: streetView.getPov().pitch
            };
            this.$emit('set-pov', this.pov);
          });

          window.map.setStreetView(streetView);
        }
      };

      request.open(
        'GET',
        'https://maps.googleapis.com/maps/api/geocode/json?address=' +
          this.location +
          '&key=AIzaSyCYSEv6QzAPFbjZaAXGApLUeW6nFjwDpg8',
        true
      );
      request.send();
    }
  }
};
</script>
